var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-tooltip ml-auto"},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":"213","nudge-right":"20","nudge-top":"10","offset-x":"","max-width":"213","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"img-tooltip"},'div',attrs,false),on))]}}])},[_c('div',{staticClass:"tooltip"},[_c('p',[_vm._v(_vm._s(_vm.description))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }